import {product} from '../base-service/service';

export default {
    // 获取所有已发布的产品线
    getReleaseProductList(data = {}) {
        return product('/getReleaseProductList.do', data);
    }
};
